/**
 * Model class for Attachment
 */

import * as _ from 'lodash'

const attachmentTypes = [
    ['csv', 'text/csv', 'CSV'],
    ['doc', 'application/msword', 'MS Word'],
    ['docx', 'application/vnd.openxmlformats-officedocument.wordprocessingml', 'MS Word (XML)'],
    ['docx', 'application/vnd.openxmlformats-officedocument.wordprocessingml.documentapplication/vnd.openxmlformats-officedocument.wordprocessingml.document', 'MS Word (XML)'],
    ['gif', 'image/gif', 'GIF'],
    ['heic', 'image/heic', 'HEIC'],
    ['jpg', 'image/jpeg', 'JPEG'],
    ['jpeg', 'image/jpeg', 'JPEG'],
    ['pdf', 'application/pdf', 'PDF'],
    ['png', 'image/png', 'PNG'],
    ['ppt', 'application/vnd.ms-powerpoint', 'MS PowerPoint'],
    ['pptx', 'application/vnd.openxmlformats-officedocument.presentationml.presentation', 'MS PowerPoint (XML)'],
    ['txt', 'text/plain', 'Text'],
    ['xls', 'application/excel', 'MS Excel'],
    ['xml', 'text/xml', 'XML'],
    ['zip', 'application/zip', 'Zip archive'],
]

export default {
    fields: {
        name: {
            label: 'Filename',
            type: 'text',
        },
        description: {
            label: 'Description',
            type: 'text',
        },
        type: {
            label: 'Type',
            type: 'text',
        },
    },

    getTypeLabel (value) {
        const result = attachmentTypes.find(elem => elem[1] === value)
        return result ? result[2] : value
    },

    getSizeLabel (value) {
        return value
    },

    getStatusLabel (value) {
        return _.capitalize(value)
    },

    getMimeTypes () {
        return _.uniq(attachmentTypes.map(elem => elem[1])).join(',')
    },

    getExtensions () {
        return attachmentTypes.map(elem => elem[0]).join(',')
    }
}
